export default class PluginFrame {
	constructor(frameConfig) {
		this.parentContainerSelector = frameConfig.container;
		this._isFullScreen = false;
		this._cachedScrollPositions = [];
		this._shouldScrollRestore = false;
	}

	get shadowRoot() {
		return document.querySelector(this.parentContainerSelector)?.shadowRoot;
	}

	get rootNode() {
		return this.shadowRoot?.querySelector("#frame-container");
	}

	getElementById(elementId) {
		return this.rootNode?.querySelector(`#${elementId}`);
	}

	setFullScreen(isFullScreen) {
		if (isFullScreen === this._isFullScreen) {
			return;
		}

		if (isFullScreen) {
			this._cachedScrollPositions.push([window.scrollX, window.scrollY]);
			this.rootNode.classList.add("evvnt-full-screen");
		} else {
			if (this._cachedScrollPositions.length) {
				const scrollPosition = this._cachedScrollPositions.pop();
				this._shouldScrollRestore = {
					x: scrollPosition[0],
					y: scrollPosition[1],
				};
			}

			this.rootNode.classList.remove("evvnt-full-screen");

			if (this._shouldScrollRestore) {
				const target = this._shouldScrollRestore;
				window.scrollTo(target.x, target.y);
				setTimeout(() => {
					if (window.scrollY !== target.y) {
						window.scrollTo(target.x, target.y);
					}
				}, 50);
				this._shouldScrollRestore = false;
			}
		}

		this._isFullScreen = isFullScreen;
	}
}
